import Routes from './routes';

const config = {
    Routes,
};

export default config;
